import { Dialog } from '@material-ui/core';
import React, { useState } from 'react';
import TrashIcon from '@shared/icons/TrashIcon';
import { XMarkIcon } from '@heroicons/react/24/outline';
import SquaredButton from 'shared/components/SquaredButton';
import { useDispatch } from 'react-redux';
import * as Actions from 'app/store/actions';
import { deleteCamera } from '@/app/services/camera';

const DeleteCameraModal = ({ open, onClose, camera, onSuccess }) => {
	const dispatch = useDispatch();
	const [submitting, setSubmitting] = useState(false);

	const handleSubmit = () => {
		setSubmitting(true);
		deleteCamera(camera?.id)
			.then(() => {
				setSubmitting(false);
				dispatch(Actions.showMessage({ message: 'Camera deleted successfully', variant: 'success' }));
				onSuccess?.();
				onClose();
			})
			.catch((error) => {
				setSubmitting(false);
				dispatch(
					Actions.showMessage({
						message: error?.response?.data?.message || 'Failed to delete camera',
						variant: 'error',
					})
				);
			})
			.finally(() => {
				setSubmitting(false);
			});
	};

	return (
		<Dialog
			classes={{
				paper: 'w-[90%] max-w-[400px] m-8 rounded-[12px] p-24',
			}}
			onClose={onClose}
			open={open}
		>
			<div className="flex flex-col">
				<div className="flex justify-between items-start mb-16">
					<div className="flex items-center gap-16">
						<div className="p-12 border rounded-full bg-error-secondary">
							<TrashIcon className="size-24 text-error" />
						</div>
					</div>
					<button
						className="p-8 absolute top-8 right-8 hover:bg-grey-100 rounded-full"
						onClick={onClose}
						type="button"
					>
						<XMarkIcon className="w-24 h-24 text-[#A4A7AE]" />
					</button>
				</div>
				<div className="mb-32">
					<h2 className="font-inter text-18 font-semibold leading-[28px]">Confirm Camera Deletion</h2>
					<p className="text-14 text-gray-800 leading-[20px]">
						You are about to delete the camera {camera?.camera_id}. This action will permanently remove the
						camera from the system.
					</p>
				</div>
				<div className="flex w-full gap-16 mt-32">
					<SquaredButton onClick={onClose} size="full" type="button" variant="outline">
						Cancel
					</SquaredButton>
					<SquaredButton
						disabled={submitting}
						onClick={handleSubmit}
						size="full"
						type="submit"
						variant="error"
					>
						Delete
					</SquaredButton>
				</div>
			</div>
		</Dialog>
	);
};

export default DeleteCameraModal;
